import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import styles from './ReactivateSubscriptionBanner.module.css';
import { useAuth } from '../lib/frontend/auth';
import InstrumentedLink from './InstrumentedLink';
import { CATEGORIES } from '../lib/universal/types';
import dayjs from 'dayjs';

const ReactivateSubscriptionBanner: React.FC = () => {
  const { profile } = useAuth();

  if (profile && profile.hasSubscription && profile.isSubscriptionCancelled) {
    return (
      <Row className={styles.reactivateBanner}>
        <Col className={styles.bannerText}>
          You only have access until{' '}
          <strong>
            {dayjs(profile.accessEndTimestamp).toDate().toDateString()}
          </strong>
          .{' '}
          <InstrumentedLink
            internalHref="/billing/subscribe"
            label="reactivate_subscription_banner_reactivate_now_link"
            category={CATEGORIES.BILLING}
          >
            Reactivate your account now
          </InstrumentedLink>
          .
        </Col>
      </Row>
    );
  }

  return null;
};

export default ReactivateSubscriptionBanner;
